"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeList = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const column_count_1 = require("./hooks/column-count");
const strategy_attribute_item_1 = require("./strategy-attribute-item");
const hooks_1 = require("../../../hooks");
const table_columns_1 = require("../../../common/table-columns");
const components_1 = require("../../../components");
const context_1 = require("../../../context");
const generic_1 = require("../../../generic");
const hooks_2 = require("../../../hooks");
const product_table_dynamic_columns_1 = require("../../../hooks/product-table-dynamic-columns");
const products_table_1 = require("../../../store/catalogs/products-table");
const store_1 = require("../../../../store");
const AttributeList = ({ attributes, hasNextPage, moreItemsLoading, isDisabled, loadMoreError, checkIsExpanded, onLoadMore, onExpand, onEdit, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const sortingItem = (0, store_1.useAttributesSort)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { ref, columnCount, itemWidth, itemMaxWidth, } = (0, column_count_1.useColumnCount)();
    const { checkedIds = [], isValueCheckMode, correspondingAttributeInValueCheckMode, checkIfAttributeValuePairChecked, onCheck, } = (0, context_1.useCheckedAttributes)();
    const persistedReviewAttributeColumnData = (0, products_table_1.useProductsTableDynamicColumns)();
    const setPersistedReviewAttributeColumnData = (0, react_1.useCallback)((data) => {
        dispatch((0, products_table_1.setProductsDynamicTableColumns)(catalogId, data));
    }, [dispatch, catalogId]);
    const { onToggleReviewAttributeColumn } = (0, product_table_dynamic_columns_1.useReviewAttributeColumnManager)({
        persistedData: persistedReviewAttributeColumnData,
        setPersistedData: setPersistedReviewAttributeColumnData,
    });
    const { checkIsAttributeChanged } = (0, hooks_2.useIsEntityChanged)();
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading,
        hasNextPage,
        onLoadMore,
    });
    const checkIsValueChecked = (0, react_1.useCallback)((value) => checkIfAttributeValuePairChecked({ label: correspondingAttributeInValueCheckMode, value }), [checkIfAttributeValuePairChecked, correspondingAttributeInValueCheckMode]);
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    const { label: selectedAttribute, unit: selectedMeasureUnit, value: selectedAttributeValue } = selectedAttributeNode !== null && selectedAttributeNode !== void 0 ? selectedAttributeNode : {};
    const handleSelectAttributeNode = (0, react_1.useCallback)((node) => {
        const { label, unit, value } = node;
        if (label === selectedAttribute && value === selectedAttributeValue && unit === selectedMeasureUnit) {
            dispatch((0, store_1.enrichAISetSelectedAttributeNode)(null));
            return;
        }
        if (!unit) {
            const columnId = (0, table_columns_1.createColumnId)(label, { isAIEnriched: true });
            onToggleReviewAttributeColumn(columnId);
        }
        dispatch((0, store_1.enrichAISetSelectedAttributeNode)(node));
    }, [dispatch, onToggleReviewAttributeColumn, selectedAttribute, selectedAttributeValue, selectedMeasureUnit]);
    const lastItemIndex = attributes.length - 1;
    const renderAttributes = () => attributes.map((attribute, index) => {
        const { label, productCount, isMeasure, isValid, isModified, } = attribute;
        const isSelected = selectedAttribute === label;
        const isExpanded = checkIsExpanded(label);
        const isAttributeChecked = checkedIds.includes(label);
        const isAttributeValueChecked = correspondingAttributeInValueCheckMode === label;
        const keepExpanded = isSelected || isAttributeValueChecked;
        const isChanged = checkIsAttributeChanged(label);
        return (react_1.default.createElement(strategy_attribute_item_1.StrategyAttributeItem, { ref: (index === lastItemIndex && !loadMoreError) ? lastElementRef : undefined, disableGutters: true, key: label, sortingItem: sortingItem, isSelected: isSelected, isSelectDisabled: isDisabled, isCheckDisabled: isDisabled || isReEnrichmentInProgress || isValueCheckMode || isMeasure || isModified, isChecked: isAttributeChecked, isChanged: isChanged || isModified, expanded: isExpanded, selectedMeasureUnit: selectedMeasureUnit, selectedAttributeValue: selectedAttributeValue, attributeName: label, isMeasure: isMeasure, isValid: isValid, productCount: productCount, keepExpanded: keepExpanded, columnCount: columnCount, itemWidth: itemWidth, itemMaxWidth: itemMaxWidth, onToggleExpand: onExpand, isValueCheckDisabled: isDisabled
                || isReEnrichmentInProgress
                || isAttributeChecked
                || (isValueCheckMode && !isAttributeValueChecked), checkIsValueChecked: isAttributeValueChecked ? checkIsValueChecked : undefined, onSelect: handleSelectAttributeNode, onCheck: onCheck, onEdit: !isModified ? onEdit : undefined }));
    });
    return (react_1.default.createElement("div", { ref: ref, className: "attributes-container-content" }, renderAttributes(), moreItemsLoading && react_1.default.createElement(generic_1.LoadingIndicator, { className: "load-more-indicator" }), loadMoreError && react_1.default.createElement(components_1.Alert, { severity: "error" }, loadMoreError)));
};
exports.AttributeList = AttributeList;
exports.default = exports.AttributeList;
